import { getEmailTokenFromQuery } from '../../helpers/queryParamsHelpers';

import { USER_EMAIL_TOKEN } from './constants';

export function getEmailToken(): string | JsonType {
    return getEmailTokenFromQuery() || localStorage.getItem(USER_EMAIL_TOKEN) || undefined;
}
